import { FirebaseAuthentication } from './firebase'

const firebaseAuthentication = new FirebaseAuthentication()

export {
    firebaseAuthentication
}


// WEBPACK FOOTER //
// ./src/authentication/index.js